import {useRef, useState} from "react";
import {Avatar, Button, Stack, TextField, Typography} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import {API_BASE_URL} from "../config";
import {useAuth} from "../context/AuthContext";

export default function CompanyForm({
                                        initialData = {
                                            companyName: "",
                                            siret: "",
                                            tva: "",
                                            email: "",
                                            phone: "",
                                            address: "",
                                            postalCode: "",
                                            city: "",
                                            picture_path: ""
                                        },
                                        onSubmit,
                                    }) {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(initialData);
    const {isAdmin} = useAuth()

    const [logo, setLogo] = useState(null);
    const fileInputRef = useRef();

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setLogo(e.target.result);
                // onLogoChange?.(file); // Envoie le fichier au parent si besoin (pour upload backend)
            };
            reader.readAsDataURL(file);
        }
    };

    const handleClick = () => fileInputRef.current.click();

    const handleSubmit = (e) => {
        e.preventDefault();

        if (loading) return; // Empêche les soumissions multiples
        setLoading(true);

        // Contrôle des champs requis
        if (!e.currentTarget.checkValidity()) {
            e.currentTarget.reportValidity();
            setLoading(false);
            return;
        }

        onSubmit(formData, logo ? logo : null).finally(() => {
            setLoading(false);
        });
    };

    return (
        <form onSubmit={e => handleSubmit(e)} noValidate>
            <Stack spacing={3}>
                {/* Logo de l'entreprise */}
                <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
                    <Stack direction="column" spacing={2}>
                        <Avatar
                            src={logo ? logo : (initialData.picture_path ? `${API_BASE_URL}/companies/logo` : "")}
                            alt="Logo de l'entreprise"
                            sx={{
                                width: 200,
                                height: 200,
                                borderRadius: 2,
                                border: "2px solid #ddd",
                                bgcolor: logo ? "transparent" : "grey.100",
                                cursor: "pointer",
                            }}
                            onClick={() => handleClick()}
                        >
                            {!logo && <UploadIcon sx={{fontSize: 40, color: "grey.500"}}/>}
                        </Avatar>

                        <input
                            type="file"
                            accept="image/*"
                            ref={fileInputRef}
                            style={{display: "none"}}
                            onChange={handleFileSelect}
                        />
                    </Stack>

                    <Stack direction="column" spacing={2} sx={{flexGrow: 1}}>
                        {/* Infos client */}
                        <TextField
                            name="companyName"
                            label="Nom de l'entreprise"
                            value={formData.companyName}
                            onChange={handleChange}
                            fullWidth
                            required
                        />
                        <TextField
                            name="siret"
                            label="Numéro SIRET"
                            value={formData.siret}
                            onChange={handleChange}
                            fullWidth
                            required
                            disabled={!isAdmin()}
                        />
                        <TextField
                            name="tva"
                            label="N° TVA intracommunautaire"
                            value={formData.tva}
                            onChange={handleChange}
                            fullWidth
                            required
                            disabled={!isAdmin()}
                        />
                    </Stack>
                </Stack>

                <Typography variant="h6" sx={{mt: 2}}>
                    Contact
                </Typography>

                {/* Coordonnées */}
                <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
                    <TextField
                        name="email"
                        label="Adresse email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        fullWidth
                        sx={{flexGrow: 1}}
                        required
                    />
                    <TextField
                        name="phone"
                        label="Téléphone"
                        value={formData.phone}
                        onChange={handleChange}
                        fullWidth
                        sx={{flexGrow: 1}}
                        required
                    />
                </Stack>

                {/* Adresse */}
                <Typography variant="h6" sx={{mt: 2}}>
                    Adresse
                </Typography>
                <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
                    <TextField
                        name="address"
                        label="Adresse (n° et rue)"
                        value={formData.address}
                        onChange={handleChange}
                        fullWidth
                        sx={{flexGrow: 2}}
                        required
                    />
                    <TextField
                        name="postalCode"
                        label="Code postal"
                        value={formData.postalCode}
                        onChange={handleChange}
                        fullWidth
                        sx={{flexGrow: 1}}
                        required
                    />
                    <TextField
                        name="city"
                        label="Ville"
                        value={formData.city}
                        onChange={handleChange}
                        fullWidth
                        sx={{flexGrow: 2}}
                        required
                    />
                </Stack>

                <Button type="submit" variant="contained" size="large" disabled={loading}>
                    {loading ? "Enregistrement..." : "Enregistrer"}
                </Button>
            </Stack>
        </form>
    );
}